import { render } from "./Managers.vue?vue&type=template&id=6b56e691&scoped=true"
import script from "./Managers.vue?vue&type=script&lang=js"
export * from "./Managers.vue?vue&type=script&lang=js"

import "./Managers.vue?vue&type=style&index=0&id=6b56e691&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b56e691"]])

export default __exports__